import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
  position: relative;
  .icon-container {
    z-index: 1;
    cursor: pointer;
    height: ${toRem(32)};
    width: ${toRem(32)};
    align-items: center;
    justify-content: center;
    border-radius: ${toRem(4)};
    position: absolute;
    right: ${toRem(15)};
    top: ${toRem(15)};
    display: flex;
    background-color:rgba(28,28,28,0.54);
    .hide-icon {
      display: none;
    }
  }
  `}
`;
